import { Component, Input } from '@angular/core';
import { TCenter } from '@shared/interfaces/TCenter';
import { TProject } from '@shared/interfaces/TProject';
import { EChartsOption } from 'echarts';
import { TreatmentCenter, TreatmentItem } from 'src/app/interfaces/treatment-used-table-data.interface';
import { KamReportsService } from '../../services/kam-reports.service';

@Component({
  selector: 'app-chart-patients',
  templateUrl: './chart-patients.component.html',
  styleUrls: ['./chart-patients.component.scss']
})
export class ChartPatientsComponent {
  @Input() project: TProject;
  options: EChartsOption;

  constructor(
    private _kamReportsService: KamReportsService,
  ) {}

  get centers(): TCenter[] { return this._kamReportsService.allCenters; }

  ngOnInit(): void {
    const treatmentPatients: TreatmentItem[] = this.getTreatmentGoals();
    this.options = this.getChartOptions(treatmentPatients);
  }

  getTreatmentGoals(): TreatmentItem[] {
    // build TreatmentCenter[]
    const treatmentPatients: string[] = this.project.treatment_uses.map(item => item.name);
    let treatmentData: TreatmentCenter[] = [];
    this.centers.forEach(center => {
      const projectData = center.projectsData.filter(pd => pd.projectId === this.project.id)[0];
      if (projectData.treatment_uses_enabled?.length) {
        treatmentData.push({
          name: center.c_name || center.c_original_name,
          total: 0,
          items: treatmentPatients.map((item, index) => ({ name: item, count: projectData.treatment_uses_enabled[index] ? 1 : 0 })),
        });
      }
    });
    // sum all
    const patients: TreatmentItem[] = treatmentPatients.map(item => ({ name: item, count: 0 }));
    treatmentData.forEach(td => {
      td.items.forEach((item, index) => {
        patients[index].count += item.count;
      });
    });
    return patients;
  }

  getChartOptions(treatmentPatients: TreatmentItem[]): EChartsOption {
    const result: EChartsOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        }
      },
      legend: {
        orient: 'horizontal',
        top: 'top',
        bottom: 'auto',
        left: 'center',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
      },
      yAxis: {
        type: 'category',
        data: treatmentPatients.map(item => item.name),
      },
      series: [
        {
          // name: 'Treatment uses',
          type: 'bar',
          data: treatmentPatients.map(item => item.count),
        },
        // {
        //   name: '2. quarter 2025',
        //   type: 'bar',
        //   data: [100, 150, 200, 250, 300, 350]
        // },
      ]
    };
    return result;
  }
}
